export default __webpack_public_path__ + "static/ocorpodecristo-4e974fd924e40e543d34dab05f054c36.webp";